import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Excel } from "antd-table-saveas-excel";
import {
  callNotification,
  deepCopy,
  generateExcelData,
  getCustomizedDate,
  getPaneIndex,
  getUpdatedDataSourceForExcel,
  separateColumnsAndData,
} from "../../redux/constants";
import { callUpdateReachImpression } from "../../redux/actions/WidgetMaker/WidgetAPI";
import GraphList from "./GraphList";
import moment from "moment";
import CardList from "./CardList";
import ErrorBoundary from "../../ErrorBoundary";
import NoGraphData from "../workspace/DisplayChart/NoGraphData";
import { Button } from "antd";
import WordCloudPills from "./WordCloudPills";
import { setReachCurrentTime } from "../../redux/actions/ApiCall/apiCall";
import isEqual from "react-fast-compare";
import WordCloudColorPalate from "./WordCloudColorPalate";
import excelIcon from "../../assets/download_excel_icon.svg";
import { WarningOutlined } from "@ant-design/icons";
import twitterDepricatedWidgetImage from "../../assets/twitter_depricated_image.svg";
import { SocialMedialogoDeprecated } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { TREEMAP_DEFAULT_HEIGHT } from "../../redux/constants/enums";
import FilterByDropDown from "../shared/components/FilterByDropDown/FilterByDropDown";
import AdvGridColumnsSetting from "./AdvGrid/AdvGridColumnsSetting";
import CountSourceToggle from "../utils/charts/ClusterChart/CountSourceToggle";

const WidgetMakerChart = ({
  metaWidgetConfig,
  metaWidgetGraphData,
  metaWidgetKpiData,
  id,
  previewCardBoxStyle,
  previewCardBoxStyleWithKPI,
  refWidth,
  preview,
  dashboard,
  span_data,
  widget_index,
  section_index,
  isPreviewState,
  isdownload,
  noteExist,
  insightsExist,
  template_widget,
  AiInsights,
  widgetDiscriptionExist,
  widgetDiscription,
  isWidgetMakerPreview = false,
}) => {
  const dispatch = useDispatch();
  const chartLoader = useSelector((state) => state?.WidgetAPI?.chart_loader);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const widgetMakerGraphData1 = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );
  const widgetMakerErrorCode = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_error_code
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const isUpdateImpression = useSelector(
    (state) => state.WidgetAPI.isUpdateImpression
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  // If Error Code 20, then show the default values for quick filter dropdown
  const quickFilterDropdownValues = useSelector(
    (state) =>
      state?.WidgetAPI?.widget_maker_default_quick_filter_dropdown_values
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);

  const isPPTModalOpen = useSelector((state) => state.PPT.isPPTModalOpen);
  const [chartCondition, setchartCondition] = useState(null);
  const [cardPresent, setCardPresent] = useState(false);

  const widgetMakerGraphData =
    typeof widgetMakerGraphData1 === "string"
      ? widgetMakerGraphData1
      : widgetMakerGraphData1?.data?.[
          widgetGraphConfig?.chart_type === "combination"
            ? "combination"
            : widgetGraphConfig?.chart_type === "horizontal-bar"
            ? "bar"
            : widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type
        ];
  // If widgetMakerGraphData is a string, use quickFilterDropdownValues or widgetMakerGraphData1 as fallback
  const widgetMakerDropDownData =
    typeof widgetMakerGraphData1 === "string"
      ? quickFilterDropdownValues && Array.isArray(quickFilterDropdownValues)
        ? quickFilterDropdownValues
        : widgetMakerGraphData1
      : widgetMakerGraphData1?.data?.["dropdown"];

  let widget_metadata =
    section_index >= 0
      ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

  useEffect(() => {
    if (!metaWidgetConfig && !widgetGraphConfig) {
      return null; // Return undefined instead of null for proper cleanup
    }
    if (metaWidgetConfig || widgetGraphConfig) {
      let pivot_index = widgetGraphConfig?.breakdown_by?.findIndex(
        (d) => d?.is_pivot
      );
      if (chart_type === "sankey") {
        // to allow sankey chart without breakdown
        if (
          widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ) {
          setchartCondition(true);
        } else setchartCondition(false);
      } else if (
        chart_type === "bubble" ||
        chart_type === "heatmap" ||
        chart_type === "sunburst"
      ) {
        if (
          widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
          widgetGraphConfig?.breakdown_by?.length > 0
        )
          setchartCondition(true);
        else setchartCondition(false);
      } else if (
        chart_type === "pie" ||
        chart_type === "donut" ||
        chart_type === "wordcloud" ||
        chart_type === "line" ||
        chart_type === "bar" ||
        chart_type === "lollipop" ||
        chart_type === "horizontal-bar" ||
        chart_type === "area" ||
        chart_type === "multilayer-map" || // newly added
        chart_type === "quadrant" || // newly added
        chart_type === "treemap"
      ) {
        if (
          widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.y_axis?.y_series_1?.attribute
        )
          setchartCondition(true);
        else setchartCondition(false);
      } else if (
        chart_type === "network-graph" ||
        chart_type === "network-graph-v2"
      ) {
        if (
          widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.breakdown_by.length > 0 &&
          (widgetGraphConfig?.breakdown_by.length > 0 &&
            widgetGraphConfig?.breakdown_by?.map((b) => b?.attribute)
              ?.length) ===
            Object?.entries(widgetGraphConfig?.y_axis)?.map(
              (el) => el[1]?.attribute
            )?.length -
              1
        )
          setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "map") {
        if (widgetGraphConfig?.y_axis?.y_series_1?.attribute)
          setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "grid" || chart_type === "cluster-chart") {
        if (
          widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.y_axis?.y_series_1?.attribute
        )
          setchartCondition(true);
        else setchartCondition(false);
      } else if (
        chart_type === "scatter" || // newly added
        chart_type === "combination"
      ) {
        if (
          widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
          widgetGraphConfig?.y_axis?.y_series_2?.attribute
        )
          setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "rich-text") {
        // For rich-text, we only need rich_fields to consider it ready
        if (
          widgetGraphConfig?.x_axis?.attribute ||
          (widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
            !widgetGraphConfig?.y_axis?.y_series_1?.hide_on_ui)
        )
          setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "kpi" || chart_type === "progress-kpi") {
        if (
          widgetGraphConfig?.x_axis ||
          widgetGraphConfig?.y_axis?.y_series_1?.attribute
        )
          setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "post-card" || chart_type === "news-card") {
        if (widgetGraphConfig?.order_by) setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "survey-card") {
        if (widgetGraphConfig?.order_by) setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "prolific-user") {
        if (widgetGraphConfig?.order_by) setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "review-card") {
        if (widgetGraphConfig?.order_by) setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "author-card") {
        if (widgetGraphConfig?.order_by) setchartCondition(true);
        else setchartCondition(false);
      } else if (chart_type === "pivot-grid") {
        if (
          widgetGraphConfig?.x_axis &&
          widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
          widgetGraphConfig?.breakdown_by?.length > 0 &&
          pivot_index > -1
        ) {
          setchartCondition(true);
        } else {
          setchartCondition(false);
        }
      } else {
        return null;
      }
    }

    // Card present or not in card_setiings
    if (typeof widgetMakerGraphData === "string") {
      setCardPresent(false);
    } else if (widgetGraphConfig?.card_settings?.length > 0) {
      let card = false;
      for (let item of widgetGraphConfig?.card_settings) {
        if (item?.y_series) {
          card = true;
          break;
        }
      }
      // widgetGraphConfig?.card_settings?.map((item, itemIndex) => {
      //   if(item?.y_series){
      //     card = true;
      //   }
      // });
      setCardPresent(card);
    }
  }, [widgetGraphConfig, widgetMakerGraphData]);

  let count = 0;

  const cardPosition = metaWidgetConfig
    ? metaWidgetConfig?.chart?.chart_settings?.card_position
      ? metaWidgetConfig?.chart?.chart_settings?.card_position
      : "Top"
    : widgetGraphConfig?.card_position;
  let attribute = allAttributes ? allAttributes : All_WM_attributes;

  let chart_type = widgetGraphConfig?.chart_type;
  // const chart__styles = {
  //   width: "100%",
  //   height:
  //     !isdownload || isdownload === undefined
  //       ? cardPosition == "Top" || cardPosition == "Bottom"
  //         ? metaWidgetKpiData?.kpi?.length > 0 && previewCardBoxStyleWithKPI
  //           ? previewCardBoxStyleWithKPI?.height != undefined
  //             ? "450" //previewCardBoxStyleWithKPI?.height
  //             : "450"
  //           : previewCardBoxStyle && previewCardBoxStyle?.height != undefined
  //           ? previewCardBoxStyle?.height
  //           : "450"
  //         : metaWidgetKpiData?.kpi?.length > 0 && previewCardBoxStyle
  //         ? previewCardBoxStyle?.height != undefined
  //           ? previewCardBoxStyle?.height
  //           : "450"
  //         : "450"
  //       : metaWidgetKpiData?.kpi?.length === 0 ||
  //         ((cardPosition == "Left" || cardPosition == "Right") &&
  //           metaWidgetKpiData?.kpi?.length > 0) ||
  //         !metaWidgetKpiData?.kpi
  //       ? metaWidgetConfig?.note && metaWidgetConfig?.note?.length > 0
  //         ? metaWidgetGraphData &&
  //           metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //           metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //           ? insightsExist
  //             ? widgetDiscriptionExist ? "245" : "265"
  //             : widgetDiscriptionExist ? "380" : "400"
  //           : insightsExist
  //           ? widgetDiscriptionExist ? "345" : "365"
  //           : widgetDiscriptionExist ? "480" : "500"
  //         : metaWidgetGraphData &&
  //           metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //           metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //         ? insightsExist
  //           ? widgetDiscriptionExist ? "430" : "450"
  //           : widgetDiscriptionExist ? "565" : "585"
  //         : insightsExist
  //         ? widgetDiscriptionExist ? "530" : "550"
  //         : widgetDiscriptionExist ? "665" : "685"
  //       : (cardPosition == "Top" || cardPosition == "Bottom") &&
  //         metaWidgetKpiData?.kpi?.length > 0
  //       ? metaWidgetKpiData?.kpi?.length > 5
  //         ? metaWidgetConfig?.note && metaWidgetConfig?.note?.length > 0
  //           ? metaWidgetGraphData &&
  //             metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //             metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //             ? widgetDiscriptionExist ? "145" : "165"
  //             : widgetDiscriptionExist ? "245" : "265"
  //           : metaWidgetGraphData &&
  //             metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //             metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //           ? insightsExist
  //             ? widgetDiscriptionExist ? "195" : "215"
  //             : widgetDiscriptionExist ? "330" : "350"
  //           : insightsExist
  //           ? widgetDiscriptionExist ? "295" : "315"
  //           : widgetDiscriptionExist ? "430" : "450"
  //         : metaWidgetConfig?.note && metaWidgetConfig?.note?.length > 0
  //         ? metaWidgetGraphData &&
  //           metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //           metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //           ? insightsExist
  //             ? widgetDiscriptionExist ? "140" : "160"
  //             : widgetDiscriptionExist ? "275" : "295"
  //           : insightsExist
  //           ? widgetDiscriptionExist ? "240" : "260"
  //           : widgetDiscriptionExist ? "375" : "395"
  //         : metaWidgetGraphData &&
  //           metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //           metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //         ? insightsExist
  //           ? widgetDiscriptionExist ? "325" : "345"
  //           : widgetDiscriptionExist ? "460" : "480"
  //         : insightsExist
  //         ? widgetDiscriptionExist ? "435" : "455"
  //         : widgetDiscriptionExist ? "560" : "580"
  //       : metaWidgetConfig?.note && metaWidgetConfig?.note?.length > 0
  //       ? metaWidgetGraphData &&
  //         metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //         metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //         ? widgetDiscriptionExist ? "145" : "165"
  //         : widgetDiscriptionExist ? "245" : "265"
  //       : metaWidgetGraphData &&
  //         metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
  //         metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
  //       ? insightsExist
  //         ? widgetDiscriptionExist ? "195" : "215"
  //         : widgetDiscriptionExist ? "330" : "350"
  //       : insightsExist
  //       ? widgetDiscriptionExist ? "195" : "315"
  //       : widgetDiscriptionExist ? "430" : "450",
  // };
  const getCalculatedChartStyle = () => {
    let style = {
      width: "100%",
      height: ["network-graph", "network-graph-v2"]?.includes(
        metaWidgetConfig?.chart?.chart_type || widgetGraphConfig?.chart_type
      )
        ? 600
        : metaWidgetConfig?.chart?.chart_type === "treemap" ||
          widgetGraphConfig?.chart_type === "treemap"
        ? TREEMAP_DEFAULT_HEIGHT
        : "450",
    };
    let calculatedHeight = Number(style.height);
    // This is used for except pdf/schedule
    if (!isdownload || isdownload === undefined) {
      calculatedHeight = ["network-graph", "network-graph-v2"]?.includes(
        metaWidgetConfig?.chart?.chart_type || widgetGraphConfig?.chart_type
      )
        ? 600
        : metaWidgetConfig?.chart?.chart_type === "treemap" ||
          widgetGraphConfig?.chart_type === "treemap"
        ? TREEMAP_DEFAULT_HEIGHT
        : 450;
    } else if (isdownload) {
      // FOR PDF
      calculatedHeight = 685;
      // if filter pills exists
      if (
        metaWidgetGraphData &&
        metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
        metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0
      ) {
        let len_kpi =
          metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 5
            ? 5
            : metaWidgetGraphData?.[0]?.["filter-pills"]?.length;
        calculatedHeight = calculatedHeight - Math.ceil(len_kpi / 5) * 65;
        // for header
        calculatedHeight = calculatedHeight - 34;
      }
      // 185 px for widget note
      if (
        (metaWidgetConfig?.note && metaWidgetConfig?.note?.length > 0) ||
        noteExist
      ) {
        calculatedHeight -= 185;
      }
      // 20 px for widget discription
      if (widgetDiscriptionExist) {
        calculatedHeight -= widgetDiscription?.length > 130 ? 40 : 20;
      }
      // 135 px for widget insights
      if (insightsExist) {
        calculatedHeight -= 135;
      }
      if (
        (cardPosition == "Top" ||
          cardPosition == "Bottom" ||
          ((cardPosition === "Left" || cardPosition === "Right") &&
            metaWidgetConfig?.chart?.chart_settings?.split_cards)) &&
        !metaWidgetConfig?.explode
      ) {
        //split case
        if (metaWidgetKpiData?.kpi?.[0]?.data) {
          if (metaWidgetKpiData?.kpi?.length > 0) {
            let totalNumberOfLine = 0;
            metaWidgetKpiData?.kpi?.forEach(
              (k) =>
                (totalNumberOfLine += k?.data?.length
                  ? Math?.ceil(k?.data?.length / 5)
                  : 0)
            );
            calculatedHeight =
              calculatedHeight -
              (Number(metaWidgetKpiData?.kpi?.length * 34) +
                (metaWidgetConfig?.chart?.chart_settings?.duration_comparison
                  ? Number(totalNumberOfLine * 85)
                  : Number(totalNumberOfLine * 65)));
          }
        } else if (metaWidgetKpiData?.kpi?.length > 0) {
          let len_kpi =
            metaWidgetKpiData?.kpi?.length > 15
              ? 15
              : metaWidgetKpiData?.kpi?.length;
          calculatedHeight =
            calculatedHeight -
            (metaWidgetConfig?.chart?.chart_settings?.duration_comparison
              ? Math.ceil(len_kpi / 5) * 85
              : Math.ceil(len_kpi / 5) * 65);
        }
      }
    }
    style.height = calculatedHeight?.toString();
    return style;
  };
  const chart__styles = getCalculatedChartStyle();

  const handleExport = () => {
    const excel = new Excel();
    let kpiGraphData =
      widgetGraphConfig?.chart_type === "kpi"
        ? widgetMakerGraphData
        : widgetGraphConfig?.card_settings?.length > 0 &&
          widgetGraphConfig?.card_settings?.[
            widgetGraphConfig?.card_settings?.length - 1
          ]?.response?.length > 0
        ? widgetGraphConfig?.card_settings?.[
            widgetGraphConfig?.card_settings?.length - 1
          ]?.response
        : [];
    let otherWidgetGraphData =
      widgetGraphConfig?.chart_type !== "kpi" &&
      widgetGraphConfig?.chart_type !== "grid" &&
      widgetGraphConfig?.chart_type !== "rich-text" &&
      widgetGraphConfig?.chart_type !== "pivot-grid" &&
      widgetGraphConfig?.chart_type !== "organization" &&
      widgetGraphConfig?.chart_type !== "treemap" &&
      widgetGraphConfig?.chart_type !== "cluster-chart" &&
      ((widgetMakerGraphData &&
        Object.keys(widgetMakerGraphData)?.length > 0) ||
        widgetMakerGraphData?.length > 0)
        ? widgetMakerGraphData
        : [];
    if (kpiGraphData?.length > 0) {
      if (kpiGraphData?.length > 15) {
        kpiGraphData = kpiGraphData?.slice(0, 15);
      }
      const res = separateColumnsAndData(
        kpiGraphData,
        attribute,
        widgetGraphConfig?.chart_settings
      );
      excel.addSheet("kpi-sheet");
      res.forEach((el, ind) => {
        if (el?.columns?.length) {
          excel.addColumns(el.columns);
          excel.addDataSource(el.data, {
            str2Percent: true,
          });
        }
      });
    }
    if (
      otherWidgetGraphData?.length > 0 ||
      Object.keys(otherWidgetGraphData)?.length > 0
    ) {
      let widgetMetadata = {
        ...widgetGraphConfig,
        chart: {
          chart_type: widgetGraphConfig.chart_type,
          rich_fields_content: widgetGraphConfig?.rich_fields_content,
          chart_settings: widgetGraphConfig.chart_settings,
        },
      };
      delete widgetMetadata.chart_type;
      delete widgetMetadata.chart_settings;
      let excelData = generateExcelData(
        graphConditionConfig,
        widgetMetadata,
        otherWidgetGraphData
      );
      if (excelData?.columns?.length) {
        excel
          .addSheet("chart-sheet")
          .addColumns(excelData?.columns)
          .addDataSource(excelData?.datasource, {
            str2Percent: true,
          });
      }
    }
    if (
      widgetGraphConfig?.chart_type === "grid" ||
      widgetGraphConfig?.chart_type === "pivot-grid" ||
      widgetGraphConfig?.chart_type === "cluster-chart"
    ) {
      let columns;
      let updatedDataSource;
      let currentDataSource = widgetMakerGraphData?.[0]?.dataSource?.length
        ? deepCopy(widgetMakerGraphData?.[0]?.dataSource)
        : [];
      if (
        widgetGraphConfig?.chart_settings?.show_previous_duration_comparison
      ) {
        columns = widgetMakerGraphData[0]?.columns?.map((e) => {
          return {
            title: e.title,
            dataIndex: e.title,
          };
        });
        updatedDataSource = getUpdatedDataSourceForExcel(
          currentDataSource,
          graphConditionConfig
        );
      } else if (
        widgetGraphConfig?.chart_settings?.show_previous_duration_data
      ) {
        columns = widgetMakerGraphData?.[0]?.columns;
        updatedDataSource = getUpdatedDataSourceForExcel(
          currentDataSource,
          graphConditionConfig
        );
      } else {
        columns = widgetMakerGraphData[0]?.columns
          ?.map((e) => {
            if (
              widgetMakerGraphData[0]?.row_span_on &&
              (e?.title === "row_span" || e?.dataIndex === "row_span")
            )
              return null;
            return {
              title: e.title,
              dataIndex: e.title,
            };
          })
          ?.filter((el) => el);
        updatedDataSource = getUpdatedDataSourceForExcel(
          currentDataSource,
          graphConditionConfig
        );
      }

      if (widgetGraphConfig?.chart_settings?.grid_config) {
        const columnConfig =
          widgetGraphConfig?.chart_settings?.grid_config?.columnConfig;
        if (columnConfig && columnConfig?.length > 0) {
          let rearrangedColumns = [];
          for (let configCol of columnConfig) {
            for (let col of columns) {
              if (col?.title === configCol?.title && configCol?.visible) {
                rearrangedColumns.push(col);
              }
            }
          }
          columns = rearrangedColumns;
        }
      }
      excel
        .addSheet("grid-sheet")
        .addColumns(columns)
        .addDataSource(updatedDataSource, {
          str2Percent: true,
        });
    }
    excel.saveAs("sheet.xlsx");
  };

  const handleRefresh = () => {
    callNotification(
      "Updating reach impression values, chart will refresh in sometime",
      "success"
    );
    let twoMonthsDuration = getCustomizedDate(6, "Days");

    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let y_series_array = [];
    y_series_array = Object.keys(widgetGraphConfig?.y_axis).map(
      (key) => widgetGraphConfig?.y_axis[key]
    );
    y_series_array = y_series_array?.filter((el) => el?.attribute);
    if (
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "sankey" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "pie"
    ) {
      y_series_array =
        y_series_array?.length > 1 ? [y_series_array[0]] : y_series_array;
    }
    let card_settings_data = [];
    widgetGraphConfig?.card_settings?.map((d) => {
      if (
        (d?.x_axis?.attribute || (!d?.x_axis?.attribute && d?.y_series)) &&
        d?.y_series?.attribute
      ) {
        card_settings_data = [
          ...card_settings_data,
          {
            x_axis:
              d?.x_axis == null
                ? null
                : Object.keys(d?.x_axis).length == 0
                ? null
                : d?.x_axis,
            y_series: d?.y_series,
          },
        ];
      }
    });

    let payloadObj = {
      isUpdateImpression: isUpdateImpression,
      brand_list: [
        {
          brand_id: 600,
        },
      ],
      start_date: widgetGraphConfig?.duration?.from
        ? widgetGraphConfig?.duration?.from
        : defaultDuration?.from,
      end_date: widgetGraphConfig?.duration?.to
        ? widgetGraphConfig?.duration?.to
        : defaultDuration?.to,
      brands:
        widgetGraphConfig?.brands?.length > 0
          ? widgetGraphConfig?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
      isBrandModified: widgetGraphConfig?.brands?.length > 0 ? true : false,

      filters:
        widgetGraphConfig?.filters?.length > 0
          ? widgetGraphConfig?.filters
          : [],
      x_axis: widgetGraphConfig?.x_axis && widgetGraphConfig?.x_axis,
      // Break down data
      y_axes:
        widgetGraphConfig?.breakdown_by?.length > 0
          ? widgetGraphConfig?.breakdown_by
          : widgetGraphConfig?.filter_by?.length > 0
          ? widgetGraphConfig?.filter_by
          : null,
      // y axis data
      y_series: y_series_array && y_series_array,
      // for filter dropdown in widget header
      filter_dropdown:
        widgetGraphConfig?.filter_dropdown?.length > 0
          ? widgetGraphConfig?.filter_dropdown
          : [],
      widget_name: "abc",
      chart: {
        chart_type:
          widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type,
        rich_fields_content: widgetGraphConfig?.rich_fields_content,
        chart_settings: {
          duration_comparison:
            widgetGraphConfig?.chart_settings?.duration_comparison,
          show_previous_duration_comparison:
            widgetGraphConfig?.chart_settings
              ?.show_previous_duration_comparison,
          show_previous_duration_data:
            widgetGraphConfig?.chart_settings?.show_previous_duration_data,
          show_data_labels:
            widgetGraphConfig?.chart_settings?.global_data_label,
          show_details_on_card:
            widgetGraphConfig?.chart_settings?.show_details_on_card,
          show_as_median: widgetGraphConfig?.chart_settings?.show_as_median, // this is used for scatter chart
          show_3d: widgetGraphConfig?.chart_settings?.show_3d,
          settings_3d: widgetGraphConfig?.chart_settings?.settings_3d,
          show_label_names: widgetGraphConfig?.chart_settings?.show_label_names,
          duplicate_for_brands: widgetGraphConfig?.chart_settings
            ?.duplicate_for_brands
            ? widgetGraphConfig?.chart_settings?.duplicate_for_brands
            : false,
          is_stacked: widgetGraphConfig?.chart_settings?.is_stacked,
          show_count_cards: widgetGraphConfig?.chart_settings?.data_count_card,
          card_percent: widgetGraphConfig?.chart_settings?.card_percent,
          chart_percent: widgetGraphConfig?.chart_settings?.chart_percent,
          gradient_color: widgetGraphConfig?.chart_settings?.gradient_color,
          total_row: widgetGraphConfig?.chart_settings?.total_row,
          chart_property: {
            chart_name: "Line chart",
            legend_position: "top",
            show_legend: widgetGraphConfig?.chart_property?.show_legend,
            y_axis_mode: widgetGraphConfig?.chart_property?.y_axis_mode,
          },
          y_axes_settings: widgetGraphConfig?.y_axis_settings,
          cards_settings: card_settings_data ? card_settings_data : null,
          chart_styles: widgetGraphConfig?.chart_settings?.chart_styles || null,
          cluster_chart_type:
            widgetGraphConfig?.chart_settings?.cluster_chart_type,
          cluster_style: widgetGraphConfig?.chart_settings?.cluster_style,
        },
      },
      card_settings_index: widgetGraphConfig?.card_settings?.length - 1,
      widgetGraphConfig: widgetGraphConfig,
      order_by:
        widgetGraphConfig?.chart_type === "post-card" ||
        widgetGraphConfig?.chart_type === "survey-card" ||
        widgetGraphConfig?.chart_type === "review-card" ||
        widgetGraphConfig?.chart_type === "author-card" ||
        widgetGraphConfig?.chart_type === "prolific-user"
          ? widgetGraphConfig?.order_by
          : null,
      edit: widgetGraphConfig?.edit,
      filter_by_data: widgetGraphConfig?.filter_by_data,
      filter_by: widgetGraphConfig?.postcard_pills_filter,
      tags: widgetGraphConfig?.tags ? widgetGraphConfig?.tags : [],

      filter_by_dropdown:
        widgetGraphConfig?.filter_by_dropdown?.length > 0
          ? widgetGraphConfig?.filter_by_dropdown
          : [],
      filter_by_dropdown_data:
        widgetGraphConfig?.filter_by_dropdown_data?.length > 0
          ? widgetGraphConfig?.filter_by_dropdown_data
          : [],
      multilevel_breakdown: widgetGraphConfig?.multilevel_breakdown || null,
    };
    dispatch(callUpdateReachImpression(authParams, payloadObj));

    let currentTime = new Date(new Date().getTime());
    dispatch(setReachCurrentTime(moment(currentTime).format("HH:mm")));
  };

  const showCountCards = metaWidgetConfig
    ? metaWidgetConfig?.chart?.chart_settings?.show_count_cards
    : widgetGraphConfig?.chart_settings?.data_count_card;

  let reason, plateformId;
  if (
    typeof widgetMakerGraphData === "string" &&
    widgetMakerGraphData?.includes("$DP$")
  ) {
    [reason, plateformId] = widgetMakerGraphData?.split("$DP$");
  }

  return (
    <div
      className={`w-100 widgetMaker_Main_Div p-0 border-radius-4 ${
        dashboard ? "" : "portlet1"
      }`}
      style={
        isdownload && !noteExist
          ? widgetDiscriptionExist
            ? widgetDiscription?.length > 130
              ? { height: "calc(100% - 10.5rem)" }
              : { height: "calc(100% - 8.5rem)" }
            : { height: "calc(100% - 6.5rem)" }
          : {}
      }
    >
      {!metaWidgetConfig && typeof metaWidgetGraphData !== "string" && (
        <div className="text_heading p-10 font-weight500 fontSize-16 border-bottom border-color d-flex align-items-center justify-content-between break-word">
          {widgetGraphConfig?.chart_property?.chart_name
            ? widgetGraphConfig?.chart_property?.chart_name
            : "Widget name"}
          <div className="d-flex align-items-center">
            {((widgetMakerGraphData !== "No data available" &&
              widgetGraphConfig?.chart_type === "grid" &&
              widgetGraphConfig?.x_axis?.attribute &&
              widgetGraphConfig?.y_axis?.y_series_1?.attribute) ||
              (widgetMakerGraphData !== "No data available" &&
                widgetGraphConfig?.chart_type === "pivot-grid" &&
                widgetGraphConfig?.x_axis?.attribute &&
                widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
                (widgetGraphConfig?.breakdown_by?.[0]?.is_pivot ||
                  widgetGraphConfig?.breakdown_by?.[1]?.is_pivot)) ||
              (widgetMakerGraphData !== "No data available" &&
                widgetGraphConfig?.chart_type === "kpi") ||
              (widgetGraphConfig?.card_settings?.length > 0 &&
                widgetGraphConfig?.card_settings?.[
                  widgetGraphConfig?.card_settings?.length - 1
                ]?.response?.length > 0)) && (
              <Button
                onClick={handleExport}
                className="text-center btn_Clear mr-2"
                style={{ height: "4rem" }}
              >
                <img
                  style={{
                    width: "1.4rem",
                    height: "1.4rem",
                    marginRight: "0.5rem",
                  }}
                  src={excelIcon}
                  alt="Excel Icon"
                />
                Export
              </Button>
            )}

            {/* Smart Grid option */}
            {widgetMakerGraphData !== "No data available" &&
              widgetGraphConfig?.chart_type === "grid" &&
              widgetGraphConfig?.x_axis?.attribute &&
              widgetGraphConfig?.y_axis?.y_series_1?.attribute &&
              !chartLoader && <AdvGridColumnsSetting />}

            {widgetMakerGraphData &&
              widgetMakerGraphData !== "No data available" &&
              ["wordcloud", "network-graph"]?.includes(
                widgetGraphConfig?.chart_type
              ) && (
                <>
                  <WordCloudColorPalate />
                </>
              )}
            {widgetMakerGraphData &&
              typeof widgetMakerDropDownData !== "string" &&
              widgetMakerDropDownData !== "No data available" && (
                <>
                  <FilterByDropDown
                    dropDownData={widgetMakerDropDownData}
                    metadata={widgetGraphConfig}
                    chart_type={widgetGraphConfig?.chart_type}
                    type={"widgetMaker"}
                  />
                </>
              )}

            {widgetGraphConfig?.chart_type === "cluster-chart" &&
              widgetMakerGraphData &&
              typeof widgetMakerDropDownData !== "string" &&
              widgetMakerDropDownData !== "No data available" && (
                <>
                  <CountSourceToggle />
                </>
              )}
            {/* {window.location.pathname !== "/share" && widgetMakerGraphData1?.refresh_ri && (
            <Tooltip placement="left" 
            title={refreshTime > reachCurrentTime ? `Button is disabled until ${refreshTime}` :
            "Refresh reach impression values"}>
              <Button
                disabled={refreshTime > reachCurrentTime ? true : false}
                onClick={handleRefresh} 
                className={refreshTime > reachCurrentTime ? "mr-2 ml-2 btn_Clear-disable" : "mr-2 ml-2 btn_Clear"}
              >
                <SyncOutlined
                  style={{
                    fontSize: "1.6rem",
                    color: authParams?.theme_type==="1"?'#fff':"#343a40",
                    fontWeight: 700,
                  }}
                />
              </Button>
            </Tooltip>
          )} */}
          </div>
        </div>
      )}
      {(cardPosition === "Top" ||
        (isdownload &&
          cardPosition === "Left" &&
          (metaWidgetConfig?.explode ||
            metaWidgetConfig?.chart?.chart_settings?.split_cards))) && (
        <div
          style={{ zIndex: "0" }}
          className={`${isdownload ? (noteExist ? "p-0" : "p-0 h-100") : ""}  ${
            (widgetGraphConfig?.chart_type === "post-card" ||
              widgetGraphConfig?.chart_type === "survey-card" ||
              widgetGraphConfig?.chart_type === "review-card") &&
            "position-relative bg__gray"
          }`}
        >
          {chartLoader ? (
            <>
              <div
                className="loader text-center w-100"
                style={{ height: "calc(100vh - 21.3rem)" }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </>
          ) : (
            <>
              {showCountCards &&
                (metaWidgetConfig?.chart?.chart_type !== "kpi" ||
                  widgetGraphConfig?.chart_type !== "kpi") &&
                ((!dashboard &&
                  !isPreviewState &&
                  widgetMakerGraphData &&
                  typeof widgetMakerGraphData !== "string") ||
                  dashboard ||
                  isPreviewState) &&
                !metaWidgetConfig?.render_graph_only && (
                  <ErrorBoundary>
                    <CardList
                      widget_index={widget_index}
                      section_index={section_index}
                      metaWidgetKpiData={metaWidgetKpiData}
                      widgetGraphConfig={widgetGraphConfig}
                      count={count}
                      cardPosition={
                        cardPosition === "Left" ? "Top" : cardPosition
                      }
                      widgetShareOfData={
                        metaWidgetConfig
                          ? metaWidgetConfig?.chart?.chart_settings
                              ?.card_percent
                          : widgetGraphConfig?.chart_settings?.card_percent
                      }
                      widgetDurationComparison={
                        metaWidgetConfig
                          ? metaWidgetConfig?.chart?.chart_settings
                              ?.duration_comparison
                          : widgetGraphConfig?.chart_settings
                              ?.duration_comparison
                      }
                      type={
                        metaWidgetConfig
                          ? metaWidgetConfig?.chart?.chart_type
                          : widgetGraphConfig?.chart_type
                      }
                      dashboard={dashboard}
                      PdfDownloadStatus={isdownload}
                      ppt_generating_status={isPPTModalOpen}
                      noteExist={noteExist}
                      metaWidgetConfig={metaWidgetConfig}
                      isPreviewState={isPreviewState}
                    />
                  </ErrorBoundary>
                )}

              {/* word cloud filter pills */}
              {((metaWidgetGraphData &&
                metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
                metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0) ||
                (widgetMakerGraphData &&
                  widgetGraphConfig?.chart_type === "wordcloud" &&
                  widgetMakerGraphData?.[0]?.["filter-pills"]?.length > 0)) &&
                !metaWidgetConfig?.render_kpi_only && (
                  <ErrorBoundary>
                    <WordCloudPills
                      data={
                        metaWidgetGraphData
                          ? metaWidgetGraphData?.[0]?.data
                          : widgetMakerGraphData?.[0]?.data
                      }
                      filterPills={
                        metaWidgetGraphData
                          ? metaWidgetGraphData?.[0]?.["filter-pills"]
                          : widgetMakerGraphData?.[0]?.["filter-pills"]
                      }
                      totalPageNo=""
                      metadata={metaWidgetConfig ? metaWidgetConfig : ""}
                      section_index={section_index}
                      widget_index={widget_index}
                      pagination={true}
                      isPreviewState={isPreviewState}
                      dashboard={dashboard}
                      PdfDownloadStatus={isdownload ? isdownload : false}
                      PptGeneratingStatus={
                        isPPTModalOpen ? isPPTModalOpen : false
                      }
                      chart_type={
                        metaWidgetConfig?.chart?.chart_type
                          ? metaWidgetConfig?.chart?.chart_type
                          : chart_type
                      }
                    />
                  </ErrorBoundary>
                )}

              {(metaWidgetGraphData &&
                typeof metaWidgetGraphData !== "string") ||
              (typeof widgetMakerGraphData !== "string" &&
                chartCondition &&
                widgetMakerGraphData) ||
              (isWidgetMakerPreview &&
                ["rich-text"]?.includes(
                  metaWidgetConfig?.chart?.chart_type ||
                    widgetGraphConfig?.chart_type
                )) ? (
                <>
                  {!metaWidgetConfig?.render_kpi_only ? (
                    <ErrorBoundary>
                      {" "}
                      <GraphList
                        widgetMakerGraphData={
                          metaWidgetGraphData
                            ? metaWidgetGraphData
                            : widgetMakerGraphData
                        }
                        isWidgetMakerPreview={isWidgetMakerPreview}
                        richFieldsContent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.rich_fields_content
                            : widgetGraphConfig?.rich_fields_content
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        single={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "pivot-grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "cluster-chart"
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData?.[0]?.data
                            ? widgetMakerGraphData?.[0]?.data
                            : widgetMakerGraphData
                        }
                        networkLinkLength={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type === "pivot-grid"
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : metaWidgetGraphData
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData[0]?.link_length
                            ? widgetMakerGraphData[0]?.link_length
                            : widgetMakerGraphData?.link_length
                        }
                        metadata={
                          metaWidgetConfig
                            ? metaWidgetConfig
                            : widgetGraphConfig
                        }
                        style={
                          graphConditionConfig?.depricated_widget_ids?.includes(
                            metaWidgetConfig?.widget_id
                          ) && isdownload
                            ? { width: "100%", height: "500" }
                            : chart__styles
                        }
                        desc={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.description
                            : widgetMakerGraphData?.[0]?.description
                        }
                        log={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.log
                            : widgetMakerGraphData?.[0]?.log
                        }
                        scaleFromZeroToOne={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.scale_from_0_to_1
                            : widgetMakerGraphData?.[0]?.scale_from_0_to_1
                        }
                        xaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.x_axis?.trace_name
                              ? metaWidgetConfig?.x_axis?.trace_name
                              : attribute[metaWidgetConfig?.x_axis?.attribute]
                            : widgetGraphConfig?.x_axis?.trace_name
                            ? widgetGraphConfig?.x_axis?.trace_name
                            : attribute[widgetGraphConfig?.x_axis?.attribute]
                        }
                        yaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.y_series &&
                              metaWidgetConfig?.y_series[0]?.trace_name
                              ? metaWidgetConfig?.y_series[0]?.trace_name
                              : metaWidgetConfig?.y_series &&
                                attribute[
                                  metaWidgetConfig?.y_series[0]?.attribute
                                ]
                            : widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_1?.attribute
                              ]
                        }
                        y_series2={
                          metaWidgetConfig
                            ? metaWidgetConfig?.y_series &&
                              attribute[
                                metaWidgetConfig?.y_series[1]?.attribute
                              ]
                            : widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_2?.attribute
                              ]
                        }
                        type={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_type
                            : widgetGraphConfig?.chart_type
                        }
                        stacked={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.stacked
                            : widgetMakerGraphData?.[0]?.stacked
                        }
                        legend_position={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.legend_position
                            : widgetGraphConfig?.chart_property?.legend_position
                        }
                        show_legend={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.show_legend
                            : widgetGraphConfig?.chart_property?.show_legend
                        }
                        chartGlobalDataLabel={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_data_labels
                            : widgetGraphConfig?.chart_settings
                                ?.global_data_label
                        }
                        chartShowDetailsOnCard={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_details_on_card
                            : widgetGraphConfig?.chart_settings
                                ?.show_details_on_card
                        }
                        chartStyles={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_styles
                            : widgetGraphConfig?.chart_settings?.chart_styles
                        }
                        showAsMedian={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_as_median
                            : widgetGraphConfig?.chart_settings?.show_as_median
                        }
                        chartShow3d={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings?.show_3d
                            : widgetGraphConfig?.chart_settings?.show_3d
                        }
                        chart3dOption={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.settings_3d
                            : widgetGraphConfig?.chart_settings?.settings_3d
                        }
                        chartAxisLabel={
                          metaWidgetConfig
                            ? typeof metaWidgetConfig?.chart?.chart_settings
                                ?.show_label_names === "boolean"
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.show_label_names
                              : true
                            : typeof widgetGraphConfig?.chart_settings
                                ?.show_label_names === "boolean"
                            ? widgetGraphConfig?.chart_settings
                                ?.show_label_names
                            : true
                        }
                        chartDataLabelInPercent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_percent
                            : widgetGraphConfig?.chart_settings?.chart_percent
                        }
                        chartGradientColor={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.gradient_color
                            : widgetGraphConfig?.chart_settings?.gradient_color
                        }
                        chartGlobalDataStacked={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.is_stacked
                            : widgetGraphConfig?.chart_settings?.is_stacked
                        }
                        chartMarkers={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_marker
                            : widgetGraphConfig?.show_marker
                        }
                        yAxisChartType={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings &&
                              metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings[0]?.show_as
                            : widgetGraphConfig?.y_axis_chart_type
                        }
                        yAxisScale={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings
                            : widgetGraphConfig?.y_axis_settings
                        }
                        yAxisMode={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.y_axis_mode
                            : widgetGraphConfig?.chart_property?.y_axis_mode
                        }
                        id={id}
                        widgetShareOfData={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.card_percent
                            : widgetGraphConfig?.chart_settings?.card_percent
                        }
                        widgetDurationComparison={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.duration_comparison
                        }
                        widgetDurationComparisonForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_comparison
                        }
                        widgetDurationDataForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_data
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_data
                        }
                        hideColumns={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_columns
                            : widgetGraphConfig?.chart_settings?.hide_columns
                        }
                        hideSorting={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_sorting
                            : widgetGraphConfig?.chart_settings?.hide_sorting
                        }
                        dateLabels={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.date_labels
                            : widgetGraphConfig?.chart_settings?.date_labels
                        }
                        refWidth={refWidth}
                        preview={preview}
                        dashboard={dashboard}
                        span_data={span_data}
                        metaDataCheck={metaWidgetConfig ? true : false}
                        isPreviewState={isPreviewState}
                        isdownload={isdownload}
                        metaWidgetKpiData={metaWidgetKpiData}
                        noteExist={noteExist}
                        insightsExist={insightsExist}
                        template_widget={template_widget}
                        AiInsights={AiInsights}
                        widgetDiscription={widgetDiscription}
                      />
                      {widget_metadata?.graphData?.reason &&
                      graphConditionConfig?.depricated_widget_ids?.includes(
                        metaWidgetConfig?.widget_id
                      ) ? (
                        <div className="depricated_widget_alert_div">
                          <span className="depricated_widget_alert_text">
                            <WarningOutlined className="mr-2" />
                            {widget_metadata?.graphData?.reason}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </ErrorBoundary>
                  ) : (
                    ""
                  )}
                </>
              ) : typeof widgetMakerGraphData === "string" ||
                typeof metaWidgetGraphData === "string" ? (
                <>
                  {widgetMakerGraphData === "Twitter map!" ||
                  metaWidgetGraphData === "Twitter map!" ? (
                    <div className={`d-flex align-items-center full_nodata`}>
                      <div className={`w-100 text-center`}>
                        <div className="Nodata_img mb-15">
                          <img
                            src={twitterDepricatedWidgetImage}
                            alt="Twitter Depricated Widget Image"
                          />
                        </div>

                        <span className="depricated_widget_alert_text">
                          <WarningOutlined className="mr-2" />
                          Due to changes in Twitter's API, location data is
                          temporarily unavailable. We are currently <br />
                          re-engineering our system to restore your favorite
                          maps as soon as possible. Thank you for your patience.
                        </span>
                      </div>
                    </div>
                  ) : reason && plateformId ? (
                    <div className={`d-flex align-items-center full_nodata`}>
                      <div
                        className={`w-100 text-center ${
                          reason && plateformId
                            ? "d-flex align-items-center flex-direction-column"
                            : ""
                        }`}
                      >
                        <div className="Nodata_img mb-15">
                          <img
                            src={SocialMedialogoDeprecated?.[plateformId]}
                            alt="Twitter Depricated Widget Image"
                          />
                        </div>

                        <span
                          className="depricated_widget_alert_text"
                          style={{
                            width: reason && plateformId ? "70%" : "auto",
                          }}
                        >
                          <WarningOutlined className="mr-2" />
                          <span> {reason}</span>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="portlet__body p-15">
                      <ErrorBoundary>
                        <NoGraphData
                          isPreviewState={isPreviewState}
                          errorCode={
                            widgetMakerErrorCode === 3
                              ? widgetMakerGraphData
                              : isPreviewState
                              ? metaWidgetGraphData
                              : "No Data Found"
                          }
                        />
                      </ErrorBoundary>
                    </div>
                  )}
                </>
              ) : (
                <div
                  className="d-flex text_regular-gray justify-content-center align-items-center"
                  style={{
                    height: "calc(100vh - 21.3rem)",
                  }}
                >
                  {dashboard ? (
                    <ErrorBoundary>
                      <NoGraphData errorCode="No Data Found" />
                    </ErrorBoundary>
                  ) : (
                    `Select left side attributes to the draggable fields`
                  )}
                </div>
              )}
            </>
          )}
        </div>
      )}

      {cardPosition === "Left" &&
        !(
          isdownload &&
          (metaWidgetConfig?.explode ||
            metaWidgetConfig?.chart?.chart_settings?.split_cards)
        ) && (
          <div
            className={`row m-0 pr-15 ${isPPTModalOpen ? "ppt__section" : ""}`}
          >
            {chartLoader ? (
              <>
                <div
                  className="loader text-center w-100"
                  style={{ height: "calc(100vh - 15.1rem)" }}
                >
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {showCountCards &&
                  (metaWidgetConfig?.chart?.chart_type !== "kpi" ||
                    widgetGraphConfig?.chart_type !== "kpi") &&
                  ((!dashboard &&
                    !isPreviewState &&
                    widgetMakerGraphData &&
                    typeof widgetMakerGraphData !== "string") ||
                    dashboard ||
                    isPreviewState) && (
                    <div className="col-3 col-sm-12 col-lg-3 col-md-3 pl-0 kpi__column--2">
                      <ErrorBoundary>
                        <CardList
                          widget_index={widget_index}
                          section_index={section_index}
                          metaWidgetKpiData={metaWidgetKpiData}
                          widgetGraphConfig={widgetGraphConfig}
                          count={count}
                          cardPosition={cardPosition}
                          widgetShareOfData={
                            metaWidgetConfig
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.card_percent
                              : widgetGraphConfig?.chart_settings?.card_percent
                          }
                          widgetDurationComparison={
                            metaWidgetConfig
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.duration_comparison
                              : widgetGraphConfig?.chart_settings
                                  ?.duration_comparison
                          }
                          type={
                            metaWidgetConfig
                              ? metaWidgetConfig?.chart?.chart_type
                              : widgetGraphConfig?.chart_type
                          }
                          dashboard={dashboard}
                          PdfDownloadStatus={isdownload}
                          ppt_generating_status={isPPTModalOpen}
                          noteExist={noteExist}
                          metaWidgetConfig={metaWidgetConfig}
                          isPreviewState={isPreviewState}
                        />
                      </ErrorBoundary>
                    </div>
                  )}

                <div
                  className={
                    cardPresent || metaWidgetKpiData?.kpi?.length > 0
                      ? "col-9 col-sm-12 col-lg-9 col-md-9 p-0 kpi__column--9"
                      : "col-12"
                  }
                >
                  {/* word cloud filter pills */}
                  {((metaWidgetGraphData &&
                    metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
                    metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0) ||
                    (widgetMakerGraphData &&
                      widgetGraphConfig?.chart_type === "wordcloud" &&
                      widgetMakerGraphData?.[0]?.["filter-pills"]?.length >
                        0)) && (
                    <ErrorBoundary>
                      <WordCloudPills
                        data={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.data
                            : widgetMakerGraphData?.[0]?.data
                        }
                        filterPills={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]["filter-pills"]
                            : widgetMakerGraphData?.[0]["filter-pills"]
                        }
                        totalPageNo=""
                        metadata={metaWidgetConfig ? metaWidgetConfig : ""}
                        section_index={section_index}
                        widget_index={widget_index}
                        pagination={true}
                        isPreviewState={isPreviewState}
                        dashboard={dashboard}
                        PdfDownloadStatus={isdownload ? isdownload : false}
                        PptGeneratingStatus={
                          isPPTModalOpen ? isPPTModalOpen : false
                        }
                        chart_type={
                          metaWidgetConfig?.chart?.chart_type
                            ? metaWidgetConfig?.chart?.chart_type
                            : chart_type
                        }
                      />
                    </ErrorBoundary>
                  )}

                  {(metaWidgetGraphData &&
                    typeof metaWidgetGraphData !== "string") ||
                  (typeof widgetMakerGraphData !== "string" &&
                    chartCondition &&
                    widgetMakerGraphData) ||
                  (isWidgetMakerPreview &&
                    ["rich-text"]?.includes(
                      metaWidgetConfig?.chart?.chart_type ||
                        widgetGraphConfig?.chart_type
                    )) ? (
                    <ErrorBoundary>
                      {" "}
                      <GraphList
                        widgetMakerGraphData={
                          metaWidgetGraphData
                            ? metaWidgetGraphData
                            : widgetMakerGraphData
                        }
                        isWidgetMakerPreview={isWidgetMakerPreview}
                        metadata={
                          metaWidgetConfig
                            ? metaWidgetConfig
                            : widgetGraphConfig
                        }
                        richFieldsContent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.rich_fields_content
                            : widgetGraphConfig?.rich_fields_content
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        single={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "pivot-grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "cluster-chart"
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData?.[0]?.data
                            ? widgetMakerGraphData?.[0]?.data
                            : widgetMakerGraphData
                        }
                        networkLinkLength={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type === "pivot-grid"
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : metaWidgetGraphData
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData[0]?.link_length
                            ? widgetMakerGraphData[0]?.link_length
                            : widgetMakerGraphData?.link_length
                        }
                        id={id}
                        style={chart__styles}
                        desc={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.description
                            : widgetMakerGraphData?.[0]?.description
                        }
                        log={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.log
                            : widgetMakerGraphData?.[0]?.log
                        }
                        scaleFromZeroToOne={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.scale_from_0_to_1
                            : widgetMakerGraphData?.[0]?.scale_from_0_to_1
                        }
                        xaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.x_axis?.trace_name
                              ? metaWidgetConfig?.x_axis?.trace_name
                              : attribute[metaWidgetConfig?.x_axis?.attribute]
                            : widgetGraphConfig?.x_axis?.trace_name
                            ? widgetGraphConfig?.x_axis?.trace_name
                            : attribute[widgetGraphConfig?.x_axis?.attribute]
                        }
                        yaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.y_series &&
                              metaWidgetConfig?.y_series[0]?.trace_name
                              ? metaWidgetConfig?.y_series[0]?.trace_name
                              : metaWidgetConfig?.y_series &&
                                attribute[
                                  metaWidgetConfig?.y_series[0]?.attribute
                                ]
                            : widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_1?.attribute
                              ]
                        }
                        y_series2={
                          metaWidgetConfig
                            ? attribute[
                                metaWidgetConfig?.y_series[1]?.attribute
                              ]
                            : widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_2?.attribute
                              ]
                        }
                        type={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_type
                            : widgetGraphConfig?.chart_type
                        }
                        stacked={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.stacked
                            : widgetMakerGraphData?.[0]?.stacked
                        }
                        legend_position={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.legend_position
                            : widgetGraphConfig?.chart_property?.legend_position
                        }
                        show_legend={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.show_legend
                            : widgetGraphConfig?.chart_property?.show_legend
                        }
                        chartGlobalDataLabel={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_data_labels
                            : widgetGraphConfig?.chart_settings
                                ?.global_data_label
                        }
                        chartShowDetailsOnCard={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_details_on_card
                            : widgetGraphConfig?.chart_settings
                                ?.show_details_on_card
                        }
                        chartStyles={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_styles
                            : widgetGraphConfig?.chart_settings?.chart_styles
                        }
                        showAsMedian={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_as_median
                            : widgetGraphConfig?.chart_settings?.show_as_median
                        }
                        chartShow3d={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings?.show_3d
                            : widgetGraphConfig?.chart_settings?.show_3d
                        }
                        chart3dOption={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.settings_3d
                            : widgetGraphConfig?.chart_settings?.settings_3d
                        }
                        chartAxisLabel={
                          metaWidgetConfig
                            ? typeof metaWidgetConfig?.chart?.chart_settings
                                ?.show_label_names === "boolean"
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.show_label_names
                              : true
                            : typeof widgetGraphConfig?.chart_settings
                                ?.show_label_names === "boolean"
                            ? widgetGraphConfig?.chart_settings
                                ?.show_label_names
                            : true
                        }
                        chartDataLabelInPercent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_percent
                            : widgetGraphConfig?.chart_settings?.chart_percent
                        }
                        chartGradientColor={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.gradient_color
                            : widgetGraphConfig?.chart_settings?.gradient_color
                        }
                        chartGlobalDataStacked={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.is_stacked
                            : widgetGraphConfig?.chart_settings?.is_stacked
                        }
                        chartMarkers={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_marker
                            : widgetGraphConfig?.show_marker
                        }
                        yAxisChartType={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings[0]?.show_as
                            : widgetGraphConfig?.y_axis_chart_type
                        }
                        yAxisScale={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings
                            : widgetGraphConfig?.y_axis_settings
                        }
                        yAxisMode={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.y_axis_mode
                            : widgetGraphConfig?.chart_property?.y_axis_mode
                        }
                        widgetShareOfData={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.card_percent
                            : widgetGraphConfig?.chart_settings?.card_percent
                        }
                        widgetDurationComparison={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.duration_comparison
                        }
                        widgetDurationComparisonForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_comparison
                        }
                        widgetDurationDataForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_data
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_data
                        }
                        hideColumns={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_columns
                            : widgetGraphConfig?.chart_settings?.hide_columns
                        }
                        hideSorting={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_sorting
                            : widgetGraphConfig?.chart_settings?.hide_sorting
                        }
                        dateLabels={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.date_labels
                            : widgetGraphConfig?.chart_settings?.date_labels
                        }
                        dashboard={dashboard}
                        span_data={span_data}
                        metaDataCheck={metaWidgetConfig ? true : false}
                        isPreviewState={isPreviewState}
                        isdownload={isdownload}
                        metaWidgetKpiData={metaWidgetKpiData}
                        noteExist={noteExist}
                        insightsExist={insightsExist}
                        template_widget={template_widget}
                        AiInsights={AiInsights}
                        widgetDiscription={widgetDiscription}
                      />
                    </ErrorBoundary>
                  ) : typeof widgetMakerGraphData === "string" ? (
                    <>
                      {widgetMakerGraphData === "Twitter map!" ||
                      metaWidgetGraphData === "Twitter map!" ? (
                        <div
                          className={`d-flex align-items-center full_nodata`}
                        >
                          <div className={`w-100 text-center`}>
                            <div className="Nodata_img mb-15">
                              <img
                                src={twitterDepricatedWidgetImage}
                                alt="Twitter Depricated Widget Image"
                              />
                            </div>

                            <span className="depricated_widget_alert_text">
                              <WarningOutlined className="mr-2" />
                              Due to changes in Twitter's API, location data is
                              temporarily unavailable. We are currently <br />
                              re-engineering our system to restore your favorite
                              maps as soon as possible. Thank you for your
                              patience.
                            </span>
                          </div>
                        </div>
                      ) : reason && plateformId ? (
                        <div
                          className={`d-flex align-items-center full_nodata`}
                        >
                          <div
                            className={`w-100 text-center ${
                              reason && plateformId
                                ? "d-flex align-items-center flex-direction-column"
                                : ""
                            }`}
                          >
                            <div className="Nodata_img mb-15">
                              <img
                                src={SocialMedialogoDeprecated?.[plateformId]}
                                alt="Twitter Depricated Widget Image"
                              />
                            </div>

                            <span
                              className="depricated_widget_alert_text"
                              style={{
                                width: reason && plateformId ? "70%" : "auto",
                              }}
                            >
                              <WarningOutlined className="mr-2" />
                              <span>{reason}</span>
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="portlet__body p-15">
                          <ErrorBoundary>
                            <NoGraphData
                              isPreviewState={isPreviewState}
                              errorCode={
                                widgetMakerErrorCode === 3
                                  ? widgetMakerGraphData
                                  : isPreviewState
                                  ? metaWidgetGraphData
                                  : "No Data Found"
                              }
                            />
                          </ErrorBoundary>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="d-flex text_regular-gray justify-content-center align-items-center"
                      style={{
                        height: "calc(100vh - 21.3rem)",
                      }}
                    >
                      Select left side attributes to the draggable fields
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}

      {cardPosition === "Right" &&
        !(
          isdownload &&
          (metaWidgetConfig?.explode ||
            metaWidgetConfig?.chart?.chart_settings?.split_cards)
        ) && (
          <div className={`row m-0 ${isPPTModalOpen ? "ppt__section" : ""}`}>
            {chartLoader ? (
              <>
                <div
                  className="loader text-center w-100"
                  style={{ height: "calc(100vh - 15.1rem)" }}
                >
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  className={
                    cardPresent || metaWidgetKpiData?.kpi?.length > 0
                      ? "col-9 col-sm-12 col-lg-9 col-md-9 p-0 kpi__column--9"
                      : "col-12"
                  }
                >
                  <div className="col-12" style={{ marginLeft: "-0.5rem" }}>
                    {((metaWidgetGraphData &&
                      metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
                      metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0) ||
                      (widgetMakerGraphData &&
                        widgetGraphConfig?.chart_type === "wordcloud" &&
                        widgetMakerGraphData?.[0]?.["filter-pills"]?.length >
                          0)) && (
                      <ErrorBoundary>
                        <WordCloudPills
                          data={
                            metaWidgetGraphData
                              ? metaWidgetGraphData?.[0]?.data
                              : widgetMakerGraphData?.[0]?.data
                          }
                          filterPills={
                            metaWidgetGraphData
                              ? metaWidgetGraphData?.[0]?.["filter-pills"]
                              : widgetMakerGraphData?.[0]?.["filter-pills"]
                          }
                          totalPageNo=""
                          metadata={metaWidgetConfig ? metaWidgetConfig : ""}
                          section_index={section_index}
                          widget_index={widget_index}
                          pagination={true}
                          isPreviewState={isPreviewState}
                          dashboard={dashboard}
                          PdfDownloadStatus={isdownload ? isdownload : false}
                          PptGeneratingStatus={
                            isPPTModalOpen ? isPPTModalOpen : false
                          }
                          chart_type={
                            metaWidgetConfig?.chart?.chart_type
                              ? metaWidgetConfig?.chart?.chart_type
                              : chart_type
                          }
                        />
                      </ErrorBoundary>
                    )}
                  </div>

                  {(metaWidgetGraphData &&
                    typeof metaWidgetGraphData !== "string") ||
                  (typeof widgetMakerGraphData !== "string" &&
                    chartCondition &&
                    widgetMakerGraphData) ||
                  (isWidgetMakerPreview &&
                    ["rich-text"]?.includes(
                      metaWidgetConfig?.chart?.chart_type ||
                        widgetGraphConfig?.chart_type
                    )) ? (
                    <ErrorBoundary>
                      <GraphList
                        widgetMakerGraphData={
                          metaWidgetGraphData
                            ? metaWidgetGraphData
                            : widgetMakerGraphData
                        }
                        isWidgetMakerPreview={isWidgetMakerPreview}
                        metadata={
                          metaWidgetConfig
                            ? metaWidgetConfig
                            : widgetGraphConfig
                        }
                        richFieldsContent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.rich_fields_content
                            : widgetGraphConfig?.rich_fields_content
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        single={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "pivot-grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "cluster-chart"
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData?.[0]?.data
                            ? widgetMakerGraphData?.[0]?.data
                            : widgetMakerGraphData
                        }
                        networkLinkLength={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type === "pivot-grid"
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : metaWidgetGraphData
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData[0]?.link_length
                            ? widgetMakerGraphData[0]?.link_length
                            : widgetMakerGraphData?.link_length
                        }
                        style={chart__styles}
                        desc={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.description
                            : widgetMakerGraphData?.[0]?.description
                        }
                        log={
                          metaWidgetGraphData
                            ? metaWidgetGraphData[0]?.log
                            : widgetMakerGraphData[0]?.log
                        }
                        scaleFromZeroToOne={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.scale_from_0_to_1
                            : widgetMakerGraphData?.[0]?.scale_from_0_to_1
                        }
                        xaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.x_axis?.trace_name
                              ? metaWidgetConfig?.x_axis?.trace_name
                              : attribute[metaWidgetConfig?.x_axis?.attribute]
                            : widgetGraphConfig?.x_axis?.trace_name
                            ? widgetGraphConfig?.x_axis?.trace_name
                            : attribute[widgetGraphConfig?.x_axis?.attribute]
                        }
                        yaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.y_series &&
                              metaWidgetConfig?.y_series[0]?.trace_name
                              ? metaWidgetConfig?.y_series[0]?.trace_name
                              : metaWidgetConfig?.y_series &&
                                attribute[
                                  metaWidgetConfig?.y_series[0]?.attribute
                                ]
                            : widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_1?.attribute
                              ]
                        }
                        id={id}
                        y_series2={
                          metaWidgetConfig
                            ? attribute[
                                metaWidgetConfig?.y_series[1]?.attribute
                              ]
                            : widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_2?.attribute
                              ]
                        }
                        type={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_type
                            : widgetGraphConfig?.chart_type
                        }
                        stacked={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.stacked
                            : widgetMakerGraphData?.[0]?.stacked
                        }
                        legend_position={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.legend_position
                            : widgetGraphConfig?.chart_property?.legend_position
                        }
                        show_legend={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.show_legend
                            : widgetGraphConfig?.chart_property?.show_legend
                        }
                        chartGlobalDataLabel={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_data_labels
                            : widgetGraphConfig?.chart_settings
                                ?.global_data_label
                        }
                        chartShowDetailsOnCard={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_details_on_card
                            : widgetGraphConfig?.chart_settings
                                ?.show_details_on_card
                        }
                        chartStyles={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_styles
                            : widgetGraphConfig?.chart_settings?.chart_styles
                        }
                        showAsMedian={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_as_median
                            : widgetGraphConfig?.chart_settings?.show_as_median
                        }
                        chartShow3d={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings?.show_3d
                            : widgetGraphConfig?.chart_settings?.show_3d
                        }
                        chart3dOption={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.settings_3d
                            : widgetGraphConfig?.chart_settings?.settings_3d
                        }
                        chartAxisLabel={
                          metaWidgetConfig
                            ? typeof metaWidgetConfig?.chart?.chart_settings
                                ?.show_label_names === "boolean"
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.show_label_names
                              : true
                            : typeof widgetGraphConfig?.chart_settings
                                ?.show_label_names === "boolean"
                            ? widgetGraphConfig?.chart_settings
                                ?.show_label_names
                            : true
                        }
                        chartDataLabelInPercent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_percent
                            : widgetGraphConfig?.chart_settings?.chart_percent
                        }
                        chartGradientColor={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.gradient_color
                            : widgetGraphConfig?.chart_settings?.gradient_color
                        }
                        chartGlobalDataStacked={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.is_stacked
                            : widgetGraphConfig?.chart_settings?.is_stacked
                        }
                        chartMarkers={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_marker
                            : widgetGraphConfig?.show_marker
                        }
                        yAxisChartType={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings?.[0]?.show_as
                            : widgetGraphConfig?.y_axis_chart_type
                        }
                        yAxisScale={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings
                            : widgetGraphConfig?.y_axis_settings
                        }
                        yAxisMode={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.y_axis_mode
                            : widgetGraphConfig?.chart_property?.y_axis_mode
                        }
                        widgetShareOfData={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.card_percent
                            : widgetGraphConfig?.chart_settings?.card_percent
                        }
                        widgetDurationComparison={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.duration_comparison
                        }
                        widgetDurationComparisonForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_comparison
                        }
                        widgetDurationDataForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_data
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_data
                        }
                        hideColumns={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_columns
                            : widgetGraphConfig?.chart_settings?.hide_columns
                        }
                        hideSorting={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_sorting
                            : widgetGraphConfig?.chart_settings?.hide_sorting
                        }
                        dateLabels={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.date_labels
                            : widgetGraphConfig?.chart_settings?.date_labels
                        }
                        dashboard={dashboard}
                        span_data={span_data}
                        metaDataCheck={metaWidgetConfig ? true : false}
                        isPreviewState={isPreviewState}
                        isdownload={isdownload}
                        metaWidgetKpiData={metaWidgetKpiData}
                        noteExist={noteExist}
                        insightsExist={insightsExist}
                        template_widget={template_widget}
                        AiInsights={AiInsights}
                        widgetDiscription={widgetDiscription}
                      />
                    </ErrorBoundary>
                  ) : typeof widgetMakerGraphData === "string" ? (
                    <>
                      {widgetMakerGraphData === "Twitter map!" ||
                      metaWidgetGraphData === "Twitter map!" ? (
                        <div
                          className={`d-flex align-items-center full_nodata`}
                        >
                          <div className={`w-100 text-center`}>
                            <div className="Nodata_img mb-15">
                              <img
                                src={twitterDepricatedWidgetImage}
                                alt="Twitter Depricated Widget Image"
                              />
                            </div>

                            <span className="depricated_widget_alert_text">
                              <WarningOutlined className="mr-2" />
                              Due to changes in Twitter's API, location data is
                              temporarily unavailable. We are currently <br />
                              re-engineering our system to restore your favorite
                              maps as soon as possible. Thank you for your
                              patience.
                            </span>
                          </div>
                        </div>
                      ) : reason && plateformId ? (
                        <div
                          className={`d-flex align-items-center full_nodata`}
                        >
                          <div
                            className={`w-100 text-center ${
                              reason && plateformId
                                ? "d-flex align-items-center flex-direction-column"
                                : ""
                            }`}
                          >
                            <div className="Nodata_img mb-15">
                              <img
                                src={SocialMedialogoDeprecated?.[plateformId]}
                                alt="Twitter Depricated Widget Image"
                              />
                            </div>

                            <span
                              className="depricated_widget_alert_text"
                              style={{
                                width: reason && plateformId ? "70%" : "auto",
                              }}
                            >
                              <WarningOutlined className="mr-2" />
                              <span>{reason}</span>
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="portlet__body p-15">
                          <ErrorBoundary>
                            <NoGraphData
                              isPreviewState={isPreviewState}
                              errorCode={
                                widgetMakerErrorCode === 3
                                  ? widgetMakerGraphData
                                  : isPreviewState
                                  ? metaWidgetGraphData
                                  : "No Data Found"
                              }
                            />
                          </ErrorBoundary>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="d-flex text_regular-gray justify-content-center align-items-center"
                      style={{
                        height: "calc(100vh - 21.3rem)",
                      }}
                    >
                      Select left side attributes to the draggable fields
                    </div>
                  )}
                </div>

                {showCountCards &&
                  (metaWidgetConfig?.chart?.chart_type !== "kpi" ||
                    widgetGraphConfig?.chart_type !== "kpi") &&
                  ((!dashboard &&
                    !isPreviewState &&
                    widgetMakerGraphData &&
                    typeof widgetMakerGraphData !== "string") ||
                    dashboard ||
                    isPreviewState) && (
                    <div className="col-3 col-sm-12 col-lg-3 col-md-3 p-0 kpi__column--2">
                      <ErrorBoundary>
                        <CardList
                          widget_index={widget_index}
                          section_index={section_index}
                          metaWidgetKpiData={metaWidgetKpiData}
                          widgetGraphConfig={widgetGraphConfig}
                          count={count}
                          cardPosition={cardPosition}
                          widgetShareOfData={
                            metaWidgetConfig
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.card_percent
                              : widgetGraphConfig?.chart_settings?.card_percent
                          }
                          widgetDurationComparison={
                            metaWidgetConfig
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.duration_comparison
                              : widgetGraphConfig?.chart_settings
                                  ?.duration_comparison
                          }
                          type={
                            metaWidgetConfig
                              ? metaWidgetConfig?.chart?.chart_type
                              : widgetGraphConfig?.chart_type
                          }
                          dashboard={dashboard}
                          PdfDownloadStatus={isdownload}
                          ppt_generating_status={isPPTModalOpen}
                          noteExist={noteExist}
                          metaWidgetConfig={metaWidgetConfig}
                          isPreviewState={isPreviewState}
                        />
                      </ErrorBoundary>
                    </div>
                  )}
              </>
            )}
          </div>
        )}

      {(cardPosition === "Bottom" ||
        (isdownload &&
          cardPosition === "Right" &&
          (metaWidgetConfig?.explode ||
            metaWidgetConfig?.chart?.chart_settings?.split_cards))) && (
        <div className="p-0">
          {chartLoader ? (
            <>
              <div
                className="loader text-center w-100"
                style={{ height: "calc(100vh - 15.1rem)" }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </>
          ) : (
            <>
              {((metaWidgetGraphData &&
                metaWidgetConfig?.chart?.chart_type === "wordcloud" &&
                metaWidgetGraphData?.[0]?.["filter-pills"]?.length > 0) ||
                (widgetMakerGraphData &&
                  widgetGraphConfig?.chart_type === "wordcloud" &&
                  widgetMakerGraphData?.[0]?.["filter-pills"]?.length > 0)) &&
                !metaWidgetConfig?.render_kpi_only && (
                  <ErrorBoundary>
                    <WordCloudPills
                      data={
                        metaWidgetGraphData
                          ? metaWidgetGraphData?.[0]?.data
                          : widgetMakerGraphData?.[0]?.data
                      }
                      filterPills={
                        metaWidgetGraphData
                          ? metaWidgetGraphData?.[0]?.["filter-pills"]
                          : widgetMakerGraphData?.[0]?.["filter-pills"]
                      }
                      totalPageNo=""
                      metadata={metaWidgetConfig ? metaWidgetConfig : ""}
                      section_index={section_index}
                      widget_index={widget_index}
                      pagination={true}
                      isPreviewState={isPreviewState}
                      dashboard={dashboard}
                      PdfDownloadStatus={isdownload ? isdownload : false}
                      PptGeneratingStatus={
                        isPPTModalOpen ? isPPTModalOpen : false
                      }
                      chart_type={
                        metaWidgetConfig?.chart?.chart_type
                          ? metaWidgetConfig?.chart?.chart_type
                          : chart_type
                      }
                    />
                  </ErrorBoundary>
                )}

              {(metaWidgetGraphData &&
                typeof metaWidgetGraphData !== "string") ||
              (typeof widgetMakerGraphData !== "string" &&
                chartCondition &&
                widgetMakerGraphData) ||
              (isWidgetMakerPreview &&
                ["rich-text"]?.includes(
                  metaWidgetConfig?.chart?.chart_type ||
                    widgetGraphConfig?.chart_type
                )) ? (
                <>
                  {!metaWidgetConfig?.render_kpi_only ? (
                    <ErrorBoundary>
                      <GraphList
                        widgetMakerGraphData={
                          metaWidgetGraphData
                            ? metaWidgetGraphData
                            : widgetMakerGraphData
                        }
                        isWidgetMakerPreview={isWidgetMakerPreview}
                        metadata={
                          metaWidgetConfig
                            ? metaWidgetConfig
                            : widgetGraphConfig
                        }
                        richFieldsContent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.rich_fields_content
                            : widgetGraphConfig?.rich_fields_content
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        single={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "pivot-grid" ||
                          metaWidgetConfig?.chart?.chart_type ===
                            "cluster-chart"
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.data
                              ? metaWidgetGraphData?.[0]?.data
                              : metaWidgetGraphData
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData?.[0]?.data
                            ? widgetMakerGraphData?.[0]?.data
                            : widgetMakerGraphData
                        }
                        networkLinkLength={
                          metaWidgetConfig?.chart?.chart_type ===
                            "combination" ||
                          metaWidgetConfig?.chart?.chart_type === "grid" ||
                          metaWidgetConfig?.chart?.chart_type === "pivot-grid"
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : metaWidgetGraphData
                            ? metaWidgetGraphData[0]?.link_length
                              ? metaWidgetGraphData[0]?.link_length
                              : metaWidgetGraphData?.link_length
                            : widgetGraphConfig?.chart_type === "combination"
                            ? widgetMakerGraphData
                            : widgetMakerGraphData[0]?.link_length
                            ? widgetMakerGraphData[0]?.link_length
                            : widgetMakerGraphData?.link_length
                        }
                        style={chart__styles}
                        desc={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.description
                            : widgetMakerGraphData?.[0]?.description
                        }
                        id={id}
                        log={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.log
                            : widgetMakerGraphData?.[0]?.log
                        }
                        scaleFromZeroToOne={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.scale_from_0_to_1
                            : widgetMakerGraphData?.[0]?.scale_from_0_to_1
                        }
                        xaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.x_axis?.trace_name
                              ? metaWidgetConfig?.x_axis?.trace_name
                              : attribute[metaWidgetConfig?.x_axis?.attribute]
                            : widgetGraphConfig?.x_axis?.trace_name
                            ? widgetGraphConfig?.x_axis?.trace_name
                            : attribute[widgetGraphConfig?.x_axis?.attribute]
                        }
                        yaxis={
                          metaWidgetConfig
                            ? metaWidgetConfig?.y_series &&
                              metaWidgetConfig?.y_series[0]?.trace_name
                              ? metaWidgetConfig?.y_series[0]?.trace_name
                              : metaWidgetConfig?.y_series &&
                                attribute[
                                  metaWidgetConfig?.y_series[0]?.attribute
                                ]
                            : widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_1?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_1?.attribute
                              ]
                        }
                        y_series2={
                          metaWidgetConfig
                            ? attribute[
                                metaWidgetConfig?.y_series?.[1]?.attribute
                              ]
                            : widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            ? widgetGraphConfig?.y_axis?.y_series_2?.trace_name
                            : attribute[
                                widgetGraphConfig?.y_axis?.y_series_2?.attribute
                              ]
                        }
                        type={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_type
                            : widgetGraphConfig?.chart_type
                        }
                        stacked={
                          metaWidgetGraphData
                            ? metaWidgetGraphData?.[0]?.stacked
                            : widgetMakerGraphData?.[0]?.stacked
                        }
                        legend_position={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.legend_position
                            : widgetGraphConfig?.chart_property?.legend_position
                        }
                        show_legend={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.show_legend
                            : widgetGraphConfig?.chart_property?.show_legend
                        }
                        chartGlobalDataLabel={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_data_labels
                            : widgetGraphConfig?.chart_settings
                                ?.global_data_label
                        }
                        chartShowDetailsOnCard={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_details_on_card
                            : widgetGraphConfig?.chart_settings
                                ?.show_details_on_card
                        }
                        chartStyles={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_styles
                            : widgetGraphConfig?.chart_settings?.chart_styles
                        }
                        showAsMedian={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_as_median
                            : widgetGraphConfig?.chart_settings?.show_as_median
                        }
                        chartShow3d={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings?.show_3d
                            : widgetGraphConfig?.chart_settings?.show_3d
                        }
                        chart3dOption={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.settings_3d
                            : widgetGraphConfig?.chart_settings?.settings_3d
                        }
                        chartAxisLabel={
                          metaWidgetConfig
                            ? typeof metaWidgetConfig?.chart?.chart_settings
                                ?.show_label_names === "boolean"
                              ? metaWidgetConfig?.chart?.chart_settings
                                  ?.show_label_names
                              : true
                            : typeof widgetGraphConfig?.chart_settings
                                ?.show_label_names === "boolean"
                            ? widgetGraphConfig?.chart_settings
                                ?.show_label_names
                            : true
                        }
                        chartDataLabelInPercent={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_percent
                            : widgetGraphConfig?.chart_settings?.chart_percent
                        }
                        chartGradientColor={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.gradient_color
                            : widgetGraphConfig?.chart_settings?.gradient_color
                        }
                        chartGlobalDataStacked={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.is_stacked
                            : widgetGraphConfig?.chart_settings?.is_stacked
                        }
                        chartMarkers={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_marker
                            : widgetGraphConfig?.show_marker
                        }
                        yAxisChartType={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings?.[0]?.show_as
                            : widgetGraphConfig?.y_axis_chart_type
                        }
                        yAxisScale={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.y_axes_settings
                            : widgetGraphConfig?.y_axis_settings
                        }
                        yAxisMode={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.chart_property?.y_axis_mode
                            : widgetGraphConfig?.chart_property?.y_axis_mode
                        }
                        widgetShareOfData={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.card_percent
                            : widgetGraphConfig?.chart_settings?.card_percent
                        }
                        widgetDurationComparison={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.duration_comparison
                        }
                        widgetDurationComparisonForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_comparison
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_comparison
                        }
                        widgetDurationDataForChart={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.show_previous_duration_data
                            : widgetGraphConfig?.chart_settings
                                ?.show_previous_duration_data
                        }
                        hideColumns={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_columns
                            : widgetGraphConfig?.chart_settings?.hide_columns
                        }
                        hideSorting={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.hide_sorting
                            : widgetGraphConfig?.chart_settings?.hide_sorting
                        }
                        dateLabels={
                          metaWidgetConfig
                            ? metaWidgetConfig?.chart?.chart_settings
                                ?.date_labels
                            : widgetGraphConfig?.chart_settings?.date_labels
                        }
                        dashboard={dashboard}
                        span_data={span_data}
                        metaDataCheck={metaWidgetConfig ? true : false}
                        isPreviewState={isPreviewState}
                        isdownload={isdownload}
                        metaWidgetKpiData={metaWidgetKpiData}
                        noteExist={noteExist}
                        insightsExist={insightsExist}
                        template_widget={template_widget}
                        AiInsights={AiInsights}
                        widgetDiscription={widgetDiscription}
                      />
                    </ErrorBoundary>
                  ) : (
                    ""
                  )}

                  {showCountCards &&
                    (metaWidgetConfig?.chart?.chart_type !== "kpi" ||
                      widgetGraphConfig?.chart_type !== "kpi") &&
                    ((!dashboard &&
                      !isPreviewState &&
                      widgetMakerGraphData &&
                      typeof widgetMakerGraphData !== "string") ||
                      dashboard ||
                      isPreviewState) &&
                    !metaWidgetConfig?.render_graph_only && (
                      <div className={`${isdownload ? "" : "mt-15"} `}>
                        <ErrorBoundary>
                          <CardList
                            widget_index={widget_index}
                            section_index={section_index}
                            metaWidgetKpiData={metaWidgetKpiData}
                            widgetGraphConfig={widgetGraphConfig}
                            count={count}
                            cardPosition={
                              cardPosition === "Right" ? "Bottom" : cardPosition
                            }
                            widgetShareOfData={
                              metaWidgetConfig
                                ? metaWidgetConfig?.chart?.chart_settings
                                    ?.card_percent
                                : widgetGraphConfig?.chart_settings
                                    ?.card_percent
                            }
                            widgetDurationComparison={
                              metaWidgetConfig
                                ? metaWidgetConfig?.chart?.chart_settings
                                    ?.duration_comparison
                                : widgetGraphConfig?.chart_settings
                                    ?.duration_comparison
                            }
                            widgetDurationComparisonForChart={
                              metaWidgetConfig
                                ? metaWidgetConfig?.chart?.chart_settings
                                    ?.show_previous_duration_comparison
                                : widgetGraphConfig?.chart_settings
                                    ?.show_previous_duration_comparison
                            }
                            widgetDurationDataForChart={
                              metaWidgetConfig
                                ? metaWidgetConfig?.chart?.chart_settings
                                    ?.show_previous_duration_data
                                : widgetGraphConfig?.chart_settings
                                    ?.show_previous_duration_data
                            }
                            type={
                              metaWidgetConfig
                                ? metaWidgetConfig?.chart?.chart_type
                                : widgetGraphConfig?.chart_type
                            }
                            dashboard={dashboard}
                            PdfDownloadStatus={isdownload}
                            ppt_generating_status={isPPTModalOpen}
                            noteExist={noteExist}
                            metaWidgetConfig={metaWidgetConfig}
                            isPreviewState={isPreviewState}
                          />
                        </ErrorBoundary>
                      </div>
                    )}
                </>
              ) : typeof widgetMakerGraphData === "string" ? (
                <>
                  <div className="portlet__body p-15">
                    {widgetMakerGraphData === "Twitter map!" ||
                    metaWidgetGraphData === "Twitter map!" ? (
                      <div className={`d-flex align-items-center full_nodata`}>
                        <div className={`w-100 text-center`}>
                          <div className="Nodata_img mb-15">
                            <img
                              src={twitterDepricatedWidgetImage}
                              alt="Twitter Depricated Widget Image"
                            />
                          </div>

                          <span className="depricated_widget_alert_text">
                            <WarningOutlined className="mr-2" />
                            Due to changes in Twitter's API, location data is
                            temporarily unavailable. We are currently <br />
                            re-engineering our system to restore your favorite
                            maps as soon as possible. Thank you for your
                            patience.
                          </span>
                        </div>
                      </div>
                    ) : reason && plateformId ? (
                      <div className={`d-flex align-items-center full_nodata`}>
                        <div
                          className={`w-100 text-center ${
                            reason && plateformId
                              ? "d-flex align-items-center flex-direction-column"
                              : ""
                          }`}
                        >
                          <div className="Nodata_img mb-15">
                            <img
                              src={SocialMedialogoDeprecated?.[plateformId]}
                              alt="Twitter Depricated Widget Image"
                            />
                          </div>

                          <span
                            className="depricated_widget_alert_text"
                            style={{
                              width: reason && plateformId ? "70%" : "auto",
                            }}
                          >
                            <WarningOutlined className="mr-2" />
                            <span>{reason}</span>
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="portlet__body p-15">
                        <ErrorBoundary>
                          <NoGraphData
                            isPreviewState={isPreviewState}
                            errorCode={
                              widgetMakerErrorCode === 3
                                ? widgetMakerGraphData
                                : isPreviewState
                                ? metaWidgetGraphData
                                : "No Data Found"
                            }
                          />
                        </ErrorBoundary>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div
                  className="d-flex text_regular-gray justify-content-center align-items-center"
                  style={{
                    height: "calc(100vh - 21.3rem)",
                  }}
                >
                  Select left side attributes to the draggable fields
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(WidgetMakerChart, isEqual);
